import { styled } from '@mui/material/styles';
import { Button as BaseButton } from 'components/buttons';
import { updateColorLight } from 'utils/colorHelpers';

export const Container = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'space-between'
}));

export const ButtonContainer = styled('div')(() => ({
  display: 'flex',
  width: '100%',
  marginTop: '10px'
}));

export const Button = styled(BaseButton)(({ theme }) => ({
  marginTop: '5px',
  width: '100%',
  textAlign: 'center',
  color: `${theme.color.primary.contrast} !important`
}));

export const LinkButton = styled('a')(({ theme }) => ({
  background: theme.color.primary.contrast,
  color: theme.color.primary.main,
  textAlign: 'center',
  margin: '5px',
  textDecoration: 'none',
  padding: '7px',
  lineHeight: '1.875em',
  fontWeight: 700,
  fontSize: '14px',
  textTransform: 'uppercase',
  width: '100%',
  wordBreak: 'normal !important',
  border: `2px solid ${theme.color.primary.main}`,
  '&:hover': {
    background: updateColorLight(theme.color.primary.main, 95)
  }
}));

export const Title = styled('div')(({ theme }) => ({
  fontSize: theme.fontSize.xsmall,
  marginLeft: '5px'
}));

export const Line = styled('hr')(() => ({
  background: '#cccccc',
  border: 0,
  width: '100%',
  height: '1px',
  marginTop: '20px'
}));

export const FlexContainer = styled('div')(() => ({
  display: 'flex',
  flex: 1
}));
